// extracted by mini-css-extract-plugin
module.exports =  {"tooltipWrapper":"T9JFAt5nwFa6_VBxumUt","root":"wgZIqBZcobCrcZYWCUNq","label":"i_xGlSLC_eYoDcvQ1sTl","description":"dKaz8f8Y5A5rEylFbf2K"};